/* Loft Home — LUX motion layer. No dependencies. Respects prefers-reduced-motion. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, win = window;
  var reduce = win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = win.matchMedia('(min-width: 1024px) and (hover: hover)');
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };

  /* ---------- Header: compact on scroll + height var ---------- */
  var header = $('.section-header');
  function setHeaderVar() {
    var h = header ? header.getBoundingClientRect().height : 84;
    if (!root.classList.contains('is-scrolled')) root.style.setProperty('--hdr-h', Math.round(h) + 'px');
  }
  var ticking = false, lastY = -1;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = win.scrollY || win.pageYOffset;
      if (y !== lastY) {
        root.classList.toggle('is-scrolled', y > 80);
        lastY = y;
        runParallax();
        runHScroll();
      }
      ticking = false;
    });
  }
  win.addEventListener('scroll', onScroll, { passive: true });
  win.addEventListener('resize', function () { setHeaderVar(); measureHScroll(); runHScroll(); }, { passive: true });

  /* ---------- Reveal on scroll ---------- */
  var io = ('IntersectionObserver' in win) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;

  function initReveal(scope) {
    $$('[data-reveal-group]', scope).forEach(function (g) {
      var step = Number(g.getAttribute('data-reveal-group')) || 70;
      $$('[data-reveal]', g).forEach(function (el, i) { el.style.setProperty('--d', String(Math.min(i, 7) * step)); });
    });
    $$('[data-reveal]', scope).forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Parallax (desktop only) ---------- */
  var plx = [];
  var plxIO = ('IntersectionObserver' in win) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target._luxOn = e.isIntersecting; });
  }, { rootMargin: '20% 0px' }) : null;
  function initParallax(scope) {
    $$('[data-parallax]', scope).forEach(function (el) {
      if (plx.indexOf(el) > -1) return;
      plx.push(el);
      plxIO && plxIO.observe(el);
    });
  }
  function runParallax() {
    if (reduce || !desktop.matches) return;
    var vh = win.innerHeight;
    plx.forEach(function (el) {
      if (!el._luxOn) return;
      var r = el.parentElement.getBoundingClientRect();
      var speed = Number(el.getAttribute('data-parallax')) || 0.1;
      var off = (r.top + r.height / 2 - vh / 2) * -speed;
      el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(scope) {
    $$('[data-lux-hero]', scope).forEach(function (hero) {
      if (hero._lux) return; hero._lux = true;
      var slides = $$('.lux-hero__slide', hero), dots = $$('.lux-hero__dot', hero);
      var interval = Number(hero.getAttribute('data-interval')) || 7000, i = 0, timer = null;
      hero.style.setProperty('--hero-int', interval + 'ms');
      function go(n) {
        if (!slides.length) return;
        slides.forEach(function (s) { s.classList.remove('is-prev'); });
        slides[i].classList.remove('is-active'); slides[i].classList.add('is-prev'); slides[i].setAttribute('aria-hidden', 'true');
        dots[i] && dots[i].setAttribute('aria-current', 'false');
        i = (n + slides.length) % slides.length;
        var km = $('.lux-hero__media img', slides[i]); if (km) { km.style.animation = 'none'; void km.offsetWidth; km.style.animation = ''; }
        slides[i].classList.add('is-active'); slides[i].setAttribute('aria-hidden', 'false');
        dots[i] && dots[i].setAttribute('aria-current', 'true');
        var img = $('img[loading="lazy"]', slides[i]); if (img) img.loading = 'eager';
        start();
      }
      function start() { clearTimeout(timer); if (slides.length > 1 && !reduce && !hero.classList.contains('is-paused')) timer = setTimeout(function () { go(i + 1); }, interval); }
      function pause() { hero.classList.add('is-paused'); clearTimeout(timer); }
      function resume() { hero.classList.remove('is-paused'); start(); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { if (k !== i) go(k); }); });
      /* Keeps playing on mouse hover, like a video. Pauses only for keyboard focus (accessibility) and hidden tabs. */
      hero.addEventListener('focusin', function (e) { try { if (e.target.matches(':focus-visible')) pause(); } catch (err) {} });
      hero.addEventListener('focusout', function () { if (hero.classList.contains('is-paused') && !doc.hidden) resume(); });
      doc.addEventListener('visibilitychange', function () { doc.hidden ? pause() : resume(); });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); x0 = null; }, { passive: true });
      var first = $('.lux-hero__slide.is-active img', hero);
      var ready = function () { hero.classList.add('is-ready'); start(); };
      if (!first || first.complete) requestAnimationFrame(ready);
      else { first.addEventListener('load', ready, { once: true }); first.addEventListener('error', ready, { once: true }); setTimeout(ready, 1200); }
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels(scope) {
    $$('[data-lux-carousel]', scope).forEach(function (wrap) {
      if (wrap._lux) return; wrap._lux = true;
      var track = $('.lux-track', wrap), prev = $('[data-prev]', wrap), next = $('[data-next]', wrap), bar = $('.lux-progress span', wrap);
      if (!track) return;
      function step() { var f = track.firstElementChild; return f ? f.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : 300; }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= max - 4;
        if (bar) {
          var w = Math.max(10, track.clientWidth / track.scrollWidth * 100);
          bar.style.setProperty('--w', w + '%');
          bar.style.setProperty('--x', (max > 0 ? track.scrollLeft / max * (100 / w * 100 - 100) : 0) + '%');
        }
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      win.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- Horizontal scroll section (desktop) ---------- */
  var hs = [];
  function initHScroll(scope) {
    $$('[data-hscroll]', scope).forEach(function (sec) { if (hs.indexOf(sec) < 0) hs.push(sec); });
    measureHScroll(); runHScroll();
  }
  function measureHScroll() {
    hs.forEach(function (sec) {
      var track = $('.lux-types__track', sec), sticky = $('.lux-types__sticky', sec);
      if (!track || !sticky) return;
      if (reduce || !desktop.matches) { sec.removeAttribute('data-hscroll-on'); sec.style.height = ''; track.style.transform = ''; return; }
      sec.setAttribute('data-hscroll-on', '');
      var dist = Math.max(0, track.scrollWidth - track.parentElement.clientWidth);
      sec._dist = dist;
      sec.style.height = (sticky.offsetHeight + dist) + 'px';
    });
  }
  function runHScroll() {
    hs.forEach(function (sec) {
      if (!sec.hasAttribute('data-hscroll-on')) return;
      var track = $('.lux-types__track', sec), r = sec.getBoundingClientRect();
      var range = sec.offsetHeight - $('.lux-types__sticky', sec).offsetHeight;
      var p = range > 0 ? Math.min(1, Math.max(0, -r.top / range)) : 0;
      track.style.transform = 'translate3d(' + (-p * (sec._dist || 0)).toFixed(1) + 'px,0,0)';
    });
  }

  /* ---------- Ranges showcase ---------- */
  function initRanges(scope) {
    $$('[data-lux-ranges]', scope).forEach(function (sec) {
      if (sec._lux) return; sec._lux = true;
      var items = $$('.lux-ranges__item', sec), imgs = $$('.lux-ranges__img', sec);
      function set(k) {
        items.forEach(function (it, j) { it.classList.toggle('is-active', j === k); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === k); });
      }
      items.forEach(function (it, k) {
        it.addEventListener('mouseenter', function () { set(k); });
        it.addEventListener('focusin', function () { set(k); });
      });
    });
  }

  /* ---------- Magnetic buttons (subtle, desktop) ---------- */
  function initMagnetic(scope) {
    if (reduce) return;
    $$('[data-magnetic]', scope).forEach(function (el) {
      if (el._lux) return; el._lux = true;
      el.addEventListener('mousemove', function (e) {
        if (!desktop.matches) return;
        var r = el.getBoundingClientRect();
        var dx = (e.clientX - r.left - r.width / 2) / r.width, dy = (e.clientY - r.top - r.height / 2) / r.height;
        el.style.transform = 'translate(' + (dx * 8).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- Cart count bump ---------- */
  if ('MutationObserver' in win) {
    $$('[data-cart-count]').forEach(function (el) {
      new MutationObserver(function () {
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  function init(scope) {
    initReveal(scope); initParallax(scope); initHero(scope); initCarousels(scope);
    initHScroll(scope); initRanges(scope); initMagnetic(scope);
  }

  setHeaderVar();
  init(doc);
  onScroll();
  win.addEventListener('load', function () { setHeaderVar(); measureHScroll(); runHScroll(); });
  win.LuxReady = true;

  /* Theme editor support */
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); measureHScroll(); });
})();
